import { MapTo } from '@adobe/aem-react-editable-components';
import ProductTiles, { ProductTilesEditConfig } from './ProductTiles';

export default MapTo('cob-corp-acquisition/components/creditonebank/product-tiles')(ProductTiles, ProductTilesEditConfig);